import React, { useEffect, useState } from 'react';
import { ContentProvider } from './common/provider/ContentProvider';
import { ContactSales } from './common/pages/ContactSales/ContactSales';
import { Trial } from './common/pages/Trial/Trial';
import { TrialContentProvider } from './common/provider/TrialContentProvider';
import { CONTENT_IDS, FORM_TYPES, MODAL_TYPES, MODIFIER_TYPE, TRIAL_TYPES } from './common/consts';
import ModalShell from './common/pages/Trial/TrialShell';
import { useAppStore } from './common/store/appStore';
import { useShallow } from 'zustand/react/shallow';
import { getLPPlusParams } from './common/util/getLPPlusParams';

function App({
  contentId,
  formType,
  trialType,
  trialLength,
  modal,
  hero,
  ctaButton,
  ctaClassNameModifier,
  emailPlaceholder,
  trialHeroIsMaxDataAttribute,
}: {
  contentId?: string;
  formType?: string;
  trialType?: string;
  trialLength?: number;
  modal?: boolean;
  hero?: boolean;
  ctaButton?: string;
  ctaClassNameModifier?: string;
  trialHeroIsMaxDataAttribute?: boolean;
  emailPlaceholder?: string;
}) {
  const {
    setModifier,
    setContentId,
    setFormType,
    setTrialType,
    setTrialLength,
    setIsLoggedIn,
    setIsCompany,
    setSegExpQuery,
    setSegExpValue,
    setCtaButton,
    setCtaClassNameModifier,
    setEmailPlaceholder,
    setBusinessMax,
    setPlus,
    setApp,
    setIsLPPlus,
  } = useAppStore(
    useShallow((state) => ({
      setModifier: state.setModifier,
      setContentId: state.setContentId,
      setFormType: state.setFormType,
      setTrialType: state.setTrialType,
      setTrialLength: state.setTrialLength,
      setIsLoggedIn: state.setIsLoggedIn,
      setIsCompany: state.setIsCompany,
      setSegExpQuery: state.setSegExpQuery,
      setSegExpValue: state.setSegExpValue,
      setCtaButton: state.setCtaButton,
      setCtaClassNameModifier: state.setCtaClassNameModifier,
      setEmailPlaceholder: state.setEmailPlaceholder,
      setBusinessMax: state.setBusinessMax,
      setPlus: state.setPlus,
      setApp: state.setApp,
      setIsLPPlus: state.setIsLPPlus,
    }))
  );

  const [isTrial, setIsTrial] = useState(false);
  const [loading, isLoading] = useState(true);

  useEffect(() => {
    if (window.LPFormData) {
      setFormType(window.LPFormData.formType);
      setTrialLength(window.LPFormData.trialLength);
      setTrialType(window.LPFormData.trialType);
      setIsLoggedIn(window.LPFormData.isLoggedIn === true || window.LPFormData.isLoggedIn === 'true');
      setIsCompany(window.LPFormData.isCompany === true || window.LPFormData.isCompany === 'true');
      setSegExpQuery(window.LPFormData.segExpQuery);
      setSegExpValue(window.LPFormData.segExpValue);
      if (window.LPFormData?.formType === FORM_TYPES.TRIAL || window.LPFormData?.formType === FORM_TYPES.DIRECTBUY) {
        setIsTrial(true);
      }
      if (window.LPFormData?.formType === FORM_TYPES.DIRECTBUY && window.LPFormData?.trialType === TRIAL_TYPES.PREMIUM) {
        const { plus, app } = getLPPlusParams();
        setPlus(plus);
        setApp(app);
        setIsLPPlus(plus);
      }
      isLoading(false);
    }
  }, [window.LPFormData]);

  useEffect(() => {
    if (hero) {
      setFormType(FORM_TYPES.TRIAL);
      setModifier(MODIFIER_TYPE.HERO);
      setTrialLength(trialLength);
      setContentId(contentId);
      setTrialType(trialType);
      setCtaButton(ctaButton || null);
      setCtaClassNameModifier(ctaClassNameModifier || null);
      setEmailPlaceholder(emailPlaceholder || null);
      setIsTrial(true);
      isLoading(false);
      setBusinessMax(trialHeroIsMaxDataAttribute || false);
    }
    if (modal) {
      setFormType(FORM_TYPES.TRIAL);
      isLoading(false);
    }
  }, [hero, modal]);

  useEffect(() => {
    if (contentId) {
      setContentId(contentId);
    }
    if (trialType) {
      setTrialType(trialType);
    }
    if (trialLength) {
      setTrialLength(trialLength);
    }
    if (formType) {
      setFormType(formType);
    }
  }, [contentId, trialType, trialLength, formType]);

  if (loading) return <></>;

  return (
    <div className="App">
      {modal ? (
        <ModalShell />
      ) : isTrial ? (
        <TrialContentProvider>
          <Trial />
        </TrialContentProvider>
      ) : (
        <ContentProvider>
          <ContactSales />
        </ContentProvider>
      )}
    </div>
  );
}
export default App;
